"use client";
import React, { ReactElement, useEffect, useRef, useState } from "react";

import { ExpandButton } from "./ExpandButton";

interface ShowMoreProps {
  children: React.ReactNode;
  className?: string;
  buttonClassName?: string;
  maxHeight?: string | number;
  titleCollapsed?: string;
  titleExpanded?: string;
}

export const ShowMore = ({
  children,
  className,
  buttonClassName = "text-red",
  maxHeight = "256px",
  titleCollapsed = "Show more",
  titleExpanded = "Show less",
}: ShowMoreProps): ReactElement<any> => {
  const [expanded, setExpanded] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    if (containerRef.current) {
      setShowButton(
        containerRef.current.scrollHeight >
          (typeof maxHeight === "number" ? maxHeight : parseInt(maxHeight)),
      );
    }
  }, [children, maxHeight]);

  return (
    <div className={className}>
      <div
        ref={containerRef}
        className={`transition-[max-height] duration-300 overflow-hidden ${expanded ? "max-h-auto" : "max-h-[var(--max-height)]"}`}
        style={
          {
            "--max-height":
              typeof maxHeight === "number" ? `${maxHeight}px` : maxHeight,
          } as React.CSSProperties
        }
      >
        {children}
      </div>
      {showButton && (
        <ExpandButton
          expanded={expanded}
          setExpanded={setExpanded}
          className={buttonClassName}
          titleCollapsed={titleCollapsed}
          titleExpanded={titleExpanded}
        />
      )}
    </div>
  );
};
